// A page that must not be yanked away mid-work — the post editor — takes a
// hold here, and the service-worker update handler checks it before its
// `window.location.reload()`. Without this, any deploy landing while an
// author was writing reloaded the page under them and their unsaved
// paragraph was gone (this happened; the draft autosave was all that saved
// the post). Skipping the reload is safe: the old page keeps running against
// the SW's precached chunks, and the next hard navigation serves the new
// build anyway.
let holds = 0;

export const holdSwReload = () => {
  holds += 1;
};

export const releaseSwReload = () => {
  holds = Math.max(0, holds - 1);
};

export const isSwReloadHeld = () => holds > 0;
